import { Stack, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Input from '/@/v3/components/forms/input';

function MyRecommendationsMobileHeader({
    children,
    filterRecos,
    setFilterRecos,
    setStep,
    searchInput,
    setSearchInput,
}: {
    children: React.ReactNode;
    filterRecos: { search?: string };
    setFilterRecos: (filters: { search?: string }) => void;
    setStep: (step: string) => void;
    searchInput: string;
    setSearchInput: (searchInput: string) => void;
}) {
    useEffect(() => {
        setFilterRecos({ ...filterRecos, search: searchInput });
    }, [searchInput]);

    const handleInputFilter = (e: string) => {
        setSearchInput(e);
    };

    const handleClickFilter = () => {
        setFilterRecos({});
        setStep('step2');
    };

    return (
        <Stack spacing={2} justifyContent='center' direction='column' sx={{ px: 4 }}>
            <Typography sx={{ fontSize: (t) => t.typography.h5.fontSize }}>{_('Mis Recomendaciones')}</Typography>
            <Input
                value={searchInput}
                onChange={handleInputFilter}
                color={settings.app.theme}
                placeholder={_('Buscar por lote, tipo, fecha, etc.')}
                onReset={() => setSearchInput('')}
            />
            <Button variant='contained' onClick={handleClickFilter} fullWidth>
                {_('Filtros')}
            </Button>
            {children}
        </Stack>
    );
}

export default MyRecommendationsMobileHeader;
